// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".xo-img-list[data-v-2e12289c]{display:inline-block;width:100%;height:120px;cursor:pointer;margin-bottom:30px}.xo-img-list[data-v-2e12289c]:hover{border:2px solid #39f}.xo-img-list-active[data-v-2e12289c]{border:3px solid #2d8cf0}.xo-img-list img[data-v-2e12289c]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
